import { render, staticRenderFns } from "./wCustom.vue?vue&type=template&id=9645bc94&scoped=true&"
import script from "./wCustom.vue?vue&type=script&lang=js&"
export * from "./wCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9645bc94",
  null
  
)

export default component.exports